import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
import { DashboardConstants } from '../../actions/constant';
const {
  GET_INTERVENTION_GROUP_REQUEST,
  GET_INTERVENTION_GROUP_SUCCESS,
  GET_INTERVENTION_GROUP_FAILURE,
  GET_INTERVENTION_GROUP_LOADER,
  GET_INTERVENTION_GROUP_RESET,
} = DashboardConstants;

function* dashboardInterventionGroup(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_INTERVENTION_GROUP_LOADER });
    const response = yield call(dashboardServices.getInterventionGroup, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_INTERVENTION_GROUP_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_INTERVENTION_GROUP_FAILURE, payload: error });
  }
}

function* dashboardInterventionGroupSaga() {
  yield takeEvery(GET_INTERVENTION_GROUP_REQUEST, dashboardInterventionGroup);
}

export default dashboardInterventionGroupSaga;
